import { useMutation, useQuery } from "@tanstack/react-query";
import { getCampaignReport } from "../../service/query/auth";

export const useGetCampaignReport = ({ payload, page }) => {
  const campaignReporyt= useQuery({
    queryKey: ['campaignReport', payload, page],
    queryFn: () => getCampaignReport({ ...payload, page }),
    enabled: !!payload && !!page,
    keepPreviousData: true,
  },
);
  return {data:campaignReporyt?.data?.data,  ...campaignReporyt,}
};